import { render, staticRenderFns } from "./formDatostecnicos.vue?vue&type=template&id=400f5e6f&scoped=true"
import script from "./formDatostecnicos.vue?vue&type=script&lang=js"
export * from "./formDatostecnicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400f5e6f",
  null
  
)

export default component.exports